export * from './delete-zeit-art.component';
export * from './delete-zeit-art.component.module';